import { ListNode, ListItemNode } from '@lexical/list'
import { QuoteNode } from '@lexical/rich-text'
import { BeautifulMentionNode } from 'lexical-beautiful-mentions'
import { mentionsTheme } from './Mentions'

export const initialConfig = {
  namespace: 'customer-message-editor',

  nodes: [ListNode, ListItemNode, QuoteNode, BeautifulMentionNode],

  // Mapped to Tailwind CSS classes
  theme: {
    text: {
      bold: 'font-bold',
      hashtag: 'editor-text-hashtag',
      italic: 'italic',
      strikethrough: 'line-through',
      underline: 'underline',
      underlineStrikethrough: 'underline line-through',
      paragraph: 'editor-paragraph',
      placeholder: 'editor-placeholder',
      quote: 'editor-quote',
    },
    paragraph: 'mb-3',
    list: {
      ol: 'list-decimal list-inside mb-5',
      ul: 'list-disc list-inside mb-5',
      nested: {
        listitem: 'list-inside list-disc',
      },
    },
    beautifulMentions: mentionsTheme,
  },

  onError(error) {
    throw error
  },
}
